/* unplugin-vue-components disabled */import script from "./SampleDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./SampleDetails.vue?vue&type=script&lang=ts&setup=true"

import "./SampleDetails.vue?vue&type=style&index=0&id=75e8742f&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e8742f"]])

export default __exports__